import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { useTheme } from '@mui/material/styles';
import { Button, IconButton, Stack } from 'common/components/material';
import React from 'react';
import { VoteType } from '../matching-engine.utils';

export const UpvoteButton: React.FC<{
  isSelected: boolean;
  onClick?: () => void;
}> = ({ isSelected, onClick }) => {
  const { palette } = useTheme();
  const UpvoteIcon = isSelected ? ThumbUpAltIcon : ThumbUpOffAltIcon;
  const color = isSelected
    ? palette.Icons.Tertiary.IconFillPressed
    : palette.Icons.Tertiary.IconFillDefault;

  return (
    <IconButton onClick={onClick} sx={{ flexGrow: 1 }}>
      <UpvoteIcon sx={{ color }} />
    </IconButton>
  );
};

export const DownvoteButton: React.FC<{
  isSelected: boolean;
  onClick?: () => void;
}> = ({ isSelected, onClick }) => {
  const { palette } = useTheme();
  const DownvoteIcon = isSelected ? ThumbDownAltIcon : ThumbDownOffAltIcon;
  const color = isSelected
    ? palette.SpecialButtons.Delete.LabelPressed
    : palette.Icons.Tertiary.IconFillDefault;
  return (
    <IconButton onClick={onClick} sx={{ flexGrow: 1 }}>
      <DownvoteIcon sx={{ color }} />
    </IconButton>
  );
};

export const ArchiveButton: React.FC<{
  isSelected: boolean;
  canArchive?: boolean;
  onClick?: () => void;
}> = ({ isSelected, onClick, canArchive = true }) => {
  return (
    <Button
      sx={{ flexGrow: 1, visibility: canArchive ? 'visible' : 'hidden' }}
      variant={isSelected ? 'outlined' : 'text'}
      size="small"
      onClick={onClick}
    >
      {isSelected ? 'Archived' : 'Archive'}
    </Button>
  );
};

export const SkillFeedbackButtons: React.FC<{
  value: VoteType | null;
  onSelect?: (value: VoteType | null) => void;
  canArchive: boolean;
}> = ({ value, onSelect, canArchive }) => {
  return (
    <Stack direction="row">
      <UpvoteButton
        isSelected={value === VoteType.UPVOTE}
        onClick={() => onSelect && onSelect(VoteType.UPVOTE)}
      />
      <DownvoteButton
        isSelected={value === VoteType.DOWNVOTE}
        onClick={() => onSelect && onSelect(VoteType.DOWNVOTE)}
      />
      <ArchiveButton
        canArchive={canArchive}
        isSelected={value === VoteType.ARCHIVE}
        onClick={() => onSelect && onSelect(VoteType.ARCHIVE)}
      />
    </Stack>
  );
};
